module.exports = __webpack_public_path__ + "static/steve-blank-4cbce8da643e33aaf4abba47e96c7cf8.jpg";